export const exterior_view02ImageOptions = {
  angle: 'exterior_view02',
  staticOptions: {
    HullTreatment: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    SprayHoodType: 1,
    SprayHood: 1,
    Wheel: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC38/views/exterior_view02.js